export default __webpack_public_path__ + "static/media/vault buy.6ddc180f.png";